/**
 * @description 投保模式 (enum)
 */
export enum InsuranceModesEnum {
  /** 線上可販售商品，不限網投網要 */
  OnLine = 'OLN',
  /** 非線上可販售商品，僅限線下投保 */
  OffLine = 'OFL',
  /** 僅網路投保 */
  OnlineContractOnly = 'OCO',
  /** 僅網路要保 */
  OnlineProposalOnly = 'OPO'
}
